import { useEffect, useState } from 'react';
import { getConsent, setConsent, trackPageView } from '../../utils/analytics';
import './CookieConsent.css';

export default function CookieConsent() {
  // Começa oculto de propósito: a decisão depende do localStorage, que só
  // existe no navegador. Se o estado inicial fosse "visível", o banner seria
  // capturado dentro do HTML pré-renderizado e apareceria piscando até para
  // quem já respondeu — além de conflitar com a hidratação do React.
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
  }, []);

  const decide = (value) => {
    setConsent(value);
    setVisible(false);

    // Aceitou agora: registra a página atual, senão essa visita só seria
    // contada na próxima navegação.
    if (value === 'granted') trackPageView(window.location.pathname);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent" role="dialog" aria-label="Aviso de cookies">
      <div className="container d-flex flex-column flex-md-row align-items-md-center gap-3">
        <p className="cookie-consent-text mb-0">
          Usamos cookies para entender como o site é usado e melhorar o conteúdo.
          Se recusar, nenhum cookie de análise é criado.
        </p>

        <div className="d-flex gap-2 flex-shrink-0">
          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() => decide('denied')}
          >
            Recusar
          </button>

          <button
            type="button"
            className="btn btn-dark btn-sm"
            onClick={() => decide('granted')}
          >
            Aceitar
          </button>
        </div>
      </div>
    </div>
  );
}
